import { documentSlice } from 'cdx-common';
import React, { useEffect } from 'react';
import { appStore } from 'store';
import { useSession } from '../libraries/SessionProvider';


export const GeoLocalizer = () => {

    const [geoActive, setGeoActive] = React.useState<boolean>(false);
    const { user } = useSession();
    const [geoWatchId, setGeoWatchId] = React.useState<number | undefined>();

    useEffect(() => {
        setGeoActive(!!user?.id);

    }, [user]);

    useEffect(() => {
        if (geoActive) {
            if (!geoWatchId) void requestLocalisation();
        } else {
            if (geoWatchId) {
                navigator.geolocation.clearWatch(geoWatchId);
                setGeoWatchId(undefined);
            }
        }
    }, [geoActive]);

    const requestLocalisation = async () => {
        setGeoWatchId(await navigator.geolocation.watchPosition(
            position => {
                appStore.dispatch(documentSlice.actions.setDeviceLoalisation({
                    lat: position.coords.latitude,
                    long: position.coords.longitude,
                    alt: position.coords.altitude ?? undefined
                }));
            }, null, { enableHighAccuracy: true, maximumAge: 1000 }
        ));
    };
    return <></>;
};
